import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';
import {
  getMessages,
  setCompletedMessagesChannel,
  setLoadingOldMessages,
  setStartMessagesOnChannel,
} from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-old-messages-banner',
  templateUrl: './old-messages-banner.component.html',
  styleUrls: ['./old-messages-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OldMessagesBannerComponent {
  private store = inject(Store<AppStateWithChat>);

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  loadOldMessages(): void {
    const channel = this.selectedChannel();
    if (!channel) {
      return;
    }
    this.store.dispatch(setStartMessagesOnChannel({ channel, value: null }));
    this.store.dispatch(setLoadingOldMessages({ channelUID: channel.uid, value: true }));
    this.store.dispatch(setCompletedMessagesChannel({ channelUID: channel.uid, value: false }));
    this.store.dispatch(
      getMessages({
        channel,
        concat: true,
        setLoading: true,
      })
    );
  }
}
